import { Directive } from '@angular/core';

@Directive({
  selector: '[appGuideCardIcon]',
})
export class GuideCardIconDirective {}
